import { render, staticRenderFns } from "./saml-authentication.vue?vue&type=template&id=bc56f00a&"
import script from "./saml-authentication.vue?vue&type=script&lang=ts&"
export * from "./saml-authentication.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports